import { DEFAULT_CURRENCY, DEFAULT_LANGUAGE } from "@bounce/i18n"

import type { City, Region } from "@/libs/bounce/bounceSdk.types.gen"
import type { CityLink } from "@/libs/bounce/cities"
import { getCityUrlPath } from "@/libs/router"

export const filterByCountry = (city: Pick<CityLink, "country">, country: string) => city.country === country
export const filterByRegion = (city: Pick<CityLink, "region">, region: Region) => city.region === region
export const sortByName = (a: Pick<CityLink, "translatedName">, b: Pick<CityLink, "translatedName">) =>
  a.translatedName.localeCompare(b.translatedName)
export const sortByAvgSearchVolume = (
  a: Pick<CityLink, "avgMonthlySearchesQty">,
  b: Pick<CityLink, "avgMonthlySearchesQty">,
) => b.avgMonthlySearchesQty - a.avgMonthlySearchesQty

export const cityToLink = (city: Pick<CityLink, "slug" | "translatedName" | "translated">) => {
  if (!city.translated) {
    return {
      name: city.translatedName,
      href: getCityUrlPath({ city: { ...city, directorySlug: "city" }, directory: "city" }),
      locale: DEFAULT_LANGUAGE,
    }
  }

  return {
    name: city.translatedName,

    href: getCityUrlPath({ city: { ...city, directorySlug: "city" }, directory: "city" }),
  }
}

export const getCityCurrency = (city: Pick<City, "currency" | "luggagePrice">) =>
  city.luggagePrice ? city.currency : DEFAULT_CURRENCY
